import { render } from "./TicketImages.vue?vue&type=template&id=483a4394&scoped=true"
import script from "./TicketImages.vue?vue&type=script&lang=js"
export * from "./TicketImages.vue?vue&type=script&lang=js"

import "./TicketImages.vue?vue&type=style&index=0&id=483a4394&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-483a4394"]])

export default __exports__